import { render, staticRenderFns } from "./MenuCart.vue?vue&type=template&id=4ccbcb44&scoped=true&"
import script from "./MenuCart.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MenuCart.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MenuCart.vue?vue&type=style&index=0&id=4ccbcb44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccbcb44",
  null
  
)

export default component.exports